import { Component, OnInit, inject } from '@angular/core';

import { ApContentComponent, ApContentService } from '@ap/content';

import content from './instructions.content.json';

/**
 * @ngdoc component
 * @name ApNativeAppInstructionsComponent
 */
@Component({
    selector: 'ap-native-app-instructions',
    templateUrl: 'instructions.component.html',
    imports: [ApContentComponent]
})
export class ApNativeAppInstructionsComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /** {@inheritDoc}. */
    public async ngOnInit(): Promise<void> {
        this.contentService.addContentItems(content);
    }
}
